import { render, staticRenderFns } from "./Payments.handler.vue?vue&type=template&id=17c3e9de&"
import script from "./Payments.handler.vue?vue&type=script&lang=ts&"
export * from "./Payments.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports